var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8376 0H31.8915L47.1929 15.949V46.97C47.1929 50.8561 44.049 54 40.1764 54H13.8376C9.95153 54 6.80762 50.8561 6.80762 46.97V7.02996C6.80755 3.14392 9.95147 0 13.8376 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8779 0V15.8276H47.1928L31.8779 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6201 40.2908V30.4272H18.8165C19.8555 30.4272 20.6786 30.7106 21.2993 31.2908C21.92 31.8575 22.2304 32.6267 22.2304 33.5847C22.2304 34.5427 21.92 35.3118 21.2993 35.8785C20.6786 36.4587 19.8555 36.7421 18.8165 36.7421H17.1434V40.2908H14.6201ZM17.1434 34.5967H18.5332C18.911 34.5967 19.2078 34.5157 19.4103 34.3269C19.6126 34.1514 19.7206 33.9086 19.7206 33.5847C19.7206 33.2609 19.6127 33.018 19.4103 32.8426C19.2079 32.6537 18.911 32.5728 18.5332 32.5728H17.1434V34.5967ZM23.2693 40.2908V30.4272H26.764C27.4522 30.4272 28.0999 30.5217 28.7071 30.7241C29.3142 30.9265 29.8675 31.2099 30.3532 31.6012C30.839 31.979 31.2303 32.4917 31.5136 33.1394C31.7835 33.7871 31.932 34.5292 31.932 35.3658C31.932 36.1889 31.7836 36.931 31.5136 37.5787C31.2303 38.2263 30.839 38.7391 30.3532 39.1169C29.8674 39.5082 29.3142 39.7915 28.7071 39.994C28.0999 40.1963 27.4522 40.2908 26.764 40.2908H23.2693ZM25.7386 38.1454H26.4672C26.8585 38.1454 27.2228 38.105 27.5601 38.0105C27.8839 37.916 28.1943 37.7676 28.4912 37.5652C28.7745 37.3628 29.0039 37.0794 29.1658 36.7016C29.3277 36.3239 29.4087 35.8785 29.4087 35.3658C29.4087 34.8395 29.3277 34.3943 29.1658 34.0165C29.0039 33.6387 28.7745 33.3554 28.4912 33.1529C28.1943 32.9506 27.884 32.8021 27.5601 32.7077C27.2228 32.6132 26.8585 32.5727 26.4672 32.5727H25.7386V38.1454ZM33.2003 40.2908V30.4272H40.2169V32.5727H35.7236V34.1514H39.3128V36.2833H35.7236V40.2908H33.2003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconFilePdf);
export default __webpack_public_path__ + "static/media/common_icon_file_pdf.2cba0c9135e511a8b6fa68a2862bc4dc.svg";
export { ForwardRef as ReactComponent };